import { Action, Module, VuexModule } from 'vuex-module-decorators'
import {
  Account,
  ChangePassword,
  ConfirmAccountRequest,
  ConfirmPasswordChangeRequest,
  RegisterRequest,
} from '@/api/generated'
import { Api } from '@/api/api'
import { Loading } from '@/shared/utils/vuex-loading'
import {
  CHANGE_PASSWORD,
  CONFIRM_ACCOUNT,
  CONFIRM_PASSWORD_CHANGE,
  REGISTER_ACCOUNT,
} from '@/business/account/store/types'
import { LOGIN } from '@/authentication/store/types'
import { RespondecoError, wrap } from '@/shared/utils/respondeco-error'
import { RespondecoPromise } from '@/shared/utils/respondeco-promise'

const STORE_NAME = 'account'

@Module({
  name: STORE_NAME,
})
export class AccountModule extends VuexModule {
  public static readonly STORE_NAME = STORE_NAME

  @Loading(CHANGE_PASSWORD)
  @Action({
    commit: CHANGE_PASSWORD,
    rawError: true,
  })
  public changePassword(payload: ChangePassword): Promise<void> {
    return Api.Account.initiatePasswordChange({
      changePassword: payload,
    })
  }

  @Loading(CONFIRM_ACCOUNT)
  @Action({
    commit: LOGIN,
    rawError: true,
  })
  public confirmAccount(
    payload: ConfirmAccountRequest
  ): RespondecoPromise<Account, RespondecoError<Response, 'account' | 'confirmation'>> {
    return Api.Account.confirmAccount(payload)
      .then(() =>
        Api.Authentication.getLogin().catch((error: Response) => {
          throw wrap(error, 'authentication')
        })
      )
      .catch((error: RespondecoError<Response> | Response) => {
        throw wrap(error, 'confirmation')
      })
  }

  @Loading(CONFIRM_PASSWORD_CHANGE)
  @Action({
    rawError: true,
  })
  public confirmPasswordChange(payload: ConfirmPasswordChangeRequest): Promise<void> {
    return Api.Account.confirmPasswordChange(payload).catch(error => {
      throw wrap(error, 'confirmation')
    })
  }

  @Loading(REGISTER_ACCOUNT)
  @Action({
    rawError: true,
  })
  public registerAccount(payload: RegisterRequest) {
    return Api.Account.register(payload)
  }
}
